import React from 'react';
import { AdvancedRealTimeChart } from 'react-ts-tradingview-widgets';

const TrendingViewChart = () => {
  return (
    <div className='trendingview-chart res-m-bttm'>
      <AdvancedRealTimeChart
        autosize
        symbol='NASDAQ:AAPL'
        interval='60'
        timezone='Etc/UTC'
        theme='light'
        locale='en'
        toolbar_bg='#f1f3f6'
        enable_publishing={false}
        allow_symbol_change
        hide_ideas
      />
    </div>
  );
};

export default TrendingViewChart;
